import React, { useEffect, useState, useRef } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Subscribe from "../components/Subscribe";
import Email from "../assets/images/email.png";
import Default from "../assets/images/default.png";
import Waiting from "../assets/images/waiting.png";
import Sent from "../assets/images/sent.png";
import emailjs from "@emailjs/browser";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
// import Skeleton from "../components/Skeleton";
import { toast } from "react-toastify";
import ReCAPTCHA from "react-google-recaptcha";
import { Helmet } from "react-helmet";
import Success from "../components/Success";
// import { MetaTags } from "react-meta-tags";

const initialState = {
  email: "",
  username: "",
  subject: "",
  message: "",
};
const Contact = ({ metaData }) => {
  const [data, setData] = useState();
  const [form, setForm] = useState(initialState);
  const [active, setActive] = useState(null);
  const [passed, setPassed] = useState(false);
  const [openModal, setOpenModel] = useState(false);

  //  prod
  const id = "Cw1TrtdA382NCnAzNcIu";

  // dev
  // const id = "vpmEfY5KkO2YzMEgTSXB";

  const onChange = () => {
    console.log("passed");
    setPassed(true);
  };

  useEffect(() => {
    id && getHomeDataFromDB();
    setActive("Contact");
  }, [id]);

  const { email, message, subject, username } = form;
  const getHomeDataFromDB = async () => {
    const docRef = doc(db, "AboutDetails", id);
    const snapshot = await getDoc(docRef);
    if (snapshot.exists()) {
      setData({ ...snapshot.data() });
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    var nameVal = document.forms["contact"]["username"].value;
    var emailVal = document.forms["contact"]["email"].value;
    var subjectVal = document.forms["contact"]["subject"].value;
    var messageVal = document.forms["contact"]["message"].value;

    if (emailVal == null || emailVal == "") {
      document.getElementsByClassName("errorEmail")[0].style.display = "block";
      document.getElementsByClassName("errorEmail")[0].innerHTML =
        "Please enter a valid email Address";
      return false;
    } else {
      document.getElementsByClassName("errorEmail")[0].style.display = "none";
    }

    if (nameVal == null || nameVal == "") {
      document.getElementsByClassName("errorName")[0].style.display = "block";
      document.getElementsByClassName("errorName")[0].innerHTML =
        "Please add your Full Name";
      return false;
    } else {
      document.getElementsByClassName("errorName")[0].style.display = "none";
    }
    if (subjectVal == null || subjectVal == "") {
      document.getElementsByClassName("errorMessage")[0].style.display =
        "block";
      document.getElementsByClassName("errorSubject")[0].innerHTML =
        "Please Fill the subject field";
      return false;
    } else {
      document.getElementsByClassName("errorSubject")[0].style.display = "none";
    }
    if (messageVal == null || messageVal == "") {
      document.getElementsByClassName("errorMessage")[0].style.display =
        "block";
      document.getElementsByClassName("errorMessage")[0].innerHTML =
        "Please type in your message";
      return false;
    } else {
      document.getElementsByClassName("errorMessage")[0].style.display = "none";
    }
    if (!passed) {
      document.getElementsByClassName("errorRecaptcha")[0].innerHTML =
        "Recapcha Not Passed";
      return false;
    } else {
      document.querySelector(".default").style.display = "none";
      document.querySelector(".waiting").style.display = "block";
      document.querySelector(".sent").style.display = "none";
      setTimeout(function () {
        document.querySelector(".default").style.display = "none";
        document.querySelector(".waiting").style.display = "none";
        document.querySelector(".sent").style.display = "block";
      }, 4000);

      emailjs
        .sendForm(
          "service_u82ttiw",
          "template_vuly37i",
          form.current,
          "b4I2DIDCQLNVOeFQC"
        )
        .then(
          (result) => {
            setOpenModel(!openModal);
            e.target.reset();
            document.querySelector(".default").style.display = "block";
            document.querySelector(".waiting").style.display = "none";
            document.querySelector(".sent").style.display = "none";
          },
          (error) => {
            // toast.error("Message Not Sent!");
            e.target.reset();
          }
        );
    }
  };
  // push to top page after loading
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>{metaData?.title + " - Contact"} </title>
        <meta name="description" content={metaData?.description} />
        <meta property="og:title" content={metaData?.title + "- Contact"} />
        <meta property="og:description" content={metaData?.description} />
        <meta property="og:image" content={metaData?.imageUrl} />
        <link rel="canonical" href={window.location.href} />
        <meta property="og:locale" content="en_GB" />
        <meta property="og:site_name" content={metaData?.title} />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={metaData?.title + "- Contact"} />
        <meta name="twitter:description" content={metaData?.description} />
        <meta name="twitter:image" content={metaData?.imageUrl} />
      </Helmet>
      <Header active={active} />
      <Success open={openModal} onClose={() => setOpenModel(false)} />
      <div className="container-fluid pt-90">
        <div className="wrapper">
          <div className="row">
            <div className="col-md-6 ">
              <div className="contant">
                <p style={{ color: "#585AA8" }}>CONTACT US</p>
                <h2 className="podcast-title hidden">{data?.contactTitle}</h2>
                <p className="text-light hidden">{data?.contactSubTitle}</p>
                <br />
                <br />
                <br />
                <div className="contact-btn">
                  <span>
                    <img className="ico-contact" src={Email} alt="" />
                  </span>
                  <span> {data?.email}</span>
                </div>
                <br />
                <br />
                {/* <button class="secondary btn large">
                  <span>
                    <img className="ico-contact" src={Web} alt="" />
                  </span>
                  www.wiftzpodcast.com
                </button> */}
                <br />
                <br />
              </div>
            </div>
            <div className="col-md-6 ">
              <div className="form-container">
                <div className="form-content">
                  <form ref={form} onSubmit={sendEmail} name="contact">
                    <input type="hidden" name="form-name" value="contact" />
                    <div className="form">
                      <label htmlFor="email">Email Address</label>
                      <input
                        type="email"
                        name="email"
                        placeholder="Enter your email address"
                        onChange={handleChange}
                        value={email}
                      />
                      <p
                        class="errorEmail"
                        style={{
                          color: "red",
                          fontSize: "12px",
                          paddingLeft: "12px",
                        }}
                      ></p>
                    </div>
                    <div className="form">
                      <label htmlFor="email">Full Name</label>
                      <input
                        type="text"
                        name="username"
                        placeholder="Enter Name"
                        value={username}
                        onChange={handleChange}
                      />
                      <p
                        class="errorName"
                        style={{
                          color: "red",
                          fontSize: "12px",
                          paddingLeft: "12px",
                        }}
                      ></p>
                    </div>
                    <div className="form">
                      <label htmlFor="Subject">Subject</label>
                      <input
                        type="text"
                        name="subject"
                        placeholder="Enter a subject here"
                        value={subject}
                        onChange={handleChange}
                      />
                      <p
                        class="errorSubject"
                        style={{
                          color: "red",
                          fontSize: "12px",
                          paddingLeft: "12px",
                        }}
                      ></p>
                    </div>
                    <div className="form">
                      <label htmlFor="message">Message</label>
                      <textarea
                        style={{ resize: "none" }}
                        type="text"
                        name="message"
                        placeholder="Write here.."
                        value={message}
                        onChange={handleChange}
                      ></textarea>
                      <p
                        class="errorMessage"
                        style={{
                          color: "red",
                          fontSize: "12px",
                          paddingLeft: "12px",
                        }}
                      ></p>
                    </div>
                    <div className="form">
                      <ReCAPTCHA
                        theme="dark"
                        sitekey="6LdggGkjAAAAAByp0Ygr2NMCsntqHZT5nE9BpyPQ"
                        onChange={onChange}
                        className="rcpstyle"
                        style={{
                          marginLeft: "11px",
                        }}
                      />
                      <p
                        class="errorRecaptcha"
                        style={{
                          color: "red",
                          fontSize: "12px",
                          paddingLeft: "12px",
                        }}
                      ></p>
                    </div>

                    <button
                      style={{
                        float: "right",
                        background: "transparent",
                        border: "0",
                      }}
                      type="submit"
                    >
                      <img className="default" src={Default} alt="" />
                      <img
                        style={{ display: "none" }}
                        className="waiting"
                        src={Waiting}
                        alt=""
                      />
                      <img
                        style={{ display: "none" }}
                        className="sent"
                        src={Sent}
                        alt=""
                      />
                    </button>
                    <br />
                    <br />
                    <br />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Subscribe />
      <Footer />
    </>
  );
};

export default Contact;
